import { useUserStore } from '@/store/user';
import { supabase } from '@/utils/supabase';
import { router } from 'expo-router';
import { default as React, useEffect } from 'react';
import { Alert, Text, View } from 'react-native';
import GoogleButton from '../../components/GoogleButton';
import '../../global.css';

const handleTokens = async () => {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.hash.substring(1));
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');

    if (access_token && refresh_token) {
      const { data, error } = await supabase.auth.setSession({
        access_token,
        refresh_token,
      });

      if (error) {
        console.error('Error setting session:', error.message);
        Alert.alert('Error', 'Failed to authenticate');
      } else if (data) {
        const supauser = await supabase.auth.getUser();

        if (supauser.data.user?.id) {
          const user = {
            id: supauser.data.user.id,
            email: supauser.data.user.email ?? '',
            fullName: supauser.data.user.user_metadata.full_name ?? '',
            profileImage: supauser.data.user.user_metadata.avatar_url ?? '',
          };
          useUserStore.getState().setUser(user);
          console.log('Logged in:', user);
          router.replace('/(root)/(tabs)/Places');
        }
      }
    }
  }
};

const handleGoogleSignInButtonClick = async () => {
  try {
    const response = await supabase.auth.signInWithOAuth({
      provider: 'google',
    });
    //const user = await handleGoogleSignIn(response);

    if (response) {
      console.log(response);
      //router.replace('/(root)/(tabs)/Places')
    }
  } catch (error: any) {
    console.log('Error signing in', error.message);
    Alert.alert('Error', error.message);
  } finally {
  }
};

//Login logic goes here
const LoginScreen = () => {
  useEffect(() => {
    handleTokens();
  }, []);

  return (
    <View className="flex-1 bg-white p-6">
      {/* Logo and Title */}
      <View className="items-center mt-24 gap-4">
        <Text className="text-3xl font-bold text-center">Buskin</Text>
      </View>
      {/* Google Login */}
      <View className="items-center mb-6">
        <GoogleButton onPress={handleGoogleSignInButtonClick} />
      </View>
    </View>
  );
};

export default LoginScreen;
